import { Directive, HostListener, Input } from '@angular/core';
import { MembersPhotoTrackingService, TrackerElementObject } from 'projects/photos-app/src/app/share-components/members-photo-tracking.service';

@Directive({
  selector: '[guestMenuTracking]'
})
export class GuestMenuTracking {
  @Input() guestMenuTracking: string;

  constructor(private trackSvc: MembersPhotoTrackingService) { }

  @HostListener('click', ['$event']) onClick(event) {
    let value = this.guestMenuTracking.split('-');
    let tracking = new TrackerElementObject(value[0], value[1]);
    this.trackSvc.trackClickedElement('Public Menu',tracking);
  }

}
